/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import authRoles from '../../auth/authRoles';
import InstanceWrapper from '../../shared-components/layouts/InstanceWrapper';
import SectionView from './instance/SectionView';
import SectionForm from './instance/SectionForm';
import InstanceComments from '../../shared-components/InstanceComments';
import CommentForm from '../../shared-components/comments/CommentForm';
import ReplyForm from '../../shared-components/comments/ReplyForm';
import StatusDev from '../../shared-components/crud/instance/status/StatusDev';
import StatusProd from '../../shared-components/crud/instance/status/StatusProd';

const SectionsConfig = {
  routes: [
    {
      path: 'sections/:id',
      element: <InstanceWrapper />,
      children: [
        {
          path: '',
          element: <SectionView />,
          children: [
            {
              path: 'status/development',
              element: <StatusDev />
            },
            {
              path: 'status/production',
              element: <StatusProd />
            }
          ]
        },
        {
          path: 'edit',
          element: <SectionForm />,
          auth: authRoles.leadEditor
        },
        {
          path: 'comments',
          element: <InstanceComments category="sections" collection='comments' />,
          children: [
            {
              path: ':commentId/edit',
              element: <CommentForm collection='comments' />
            },
            {
              path: ':commentId/reply/:replyId/edit',
              element: <ReplyForm collection='comments' />
            }
          ]
        },
        {
          path: 'imi-comments',
          element: <InstanceComments category="sections" isIMI collection='imi_comments' />,
          children: [
            {
              path: ':commentId/edit',
              element: <CommentForm isIMI collection='imi_comments' />
            },
            {
              path: ':commentId/reply/:replyId/edit',
              element: <ReplyForm isIMI collection='imi_comments' />
            }
          ]
        },
        {
          path: 'pre-trial-comments',
          element: <InstanceComments category="sections" isIMI collection='pre_trial_comments' />,
          children: [
            {
              path: ':commentId/edit',
              element: <CommentForm isIMI collection='pre_trial_comments' />
            },
            {
              path: ':commentId/reply/:replyId/edit',
              element: <ReplyForm isIMI collection='pre_trial_comments' />
            }
          ]
        }
      ]
    }
  ]
};

export default SectionsConfig;
